import { AttributeBase, AttributeOptions } from './attribute-base';

export class ListAttribute extends AttributeBase<string> {
  public override controlType = 'list';
  public override type: string;
  public override attributes: AttributeBase<any>[] = [];
  public override display = true;
  public override options: string[] = [];

  constructor(options: AttributeOptions = {}) {
    super(options);
    this.type = options['type'] || '';
    this.controlType = options.controlType;
    this.attributes = options.attributes || [];
  }
}
